import container from "../../../libs/container/container";

const amdTopicsDetailsRelatedSmallModule = (function () {
    const name = 'topics-details__related-small-module';

    const view = container.getBaseView(name);

    view.privateVars = {

    }

    view.startup = function () {

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsDetailsRelatedSmallHeaderMediumCls, 'animate__bounce', name, {
            dynamicPosHeight: true
        });

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsDetailsRelatedSmallInfoHeaderCls, 'animate__fadeIn', name, {
            dynamicPosHeight: true
        });

        container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsDetailsRelatedSmallInfoContentCls, 'animate__fadeIn', name, {
            dynamicPosHeight: true
        });

        document.querySelectorAll(view.publicVars.cssId.anim.moduleTopicsDetailsRelatedSmallItemCls).forEach((element) => {

            const id = element.dataset.id;

            container.getService('scroll').registerAnimatedElement(view.publicVars.cssId.anim.moduleTopicsDetailsRelatedSmallItemCls + id, 'animate__zoomIn50P', name, {
                dynamicPosHeight: true
            });
        });
    };

    view.bind = function () {

    };

    view.methods = {

    }

    return {
        init: function (options) {
            view.init(options);
        }
    }
})();

export default amdTopicsDetailsRelatedSmallModule;